export const MAX_TRIGGERS = 60
export const MAX_TRIGGER_FORMULAS = 100
export const MAX_LENGTH_TRIGGER_NAME = 60
export const MAX_LENGTH_TRIGGER_PROMPT = 300
export const MAX_NEWLINES_TRIGGER_PROMPT = 4
export const MAX_LINES_TRIGGER_PROMPT = MAX_NEWLINES_TRIGGER_PROMPT + 1

